// Generated by scripts/generate-data.mjs. Do not edit manually.
import type { AnomalyDefinition, Employee, EndingDefinition, MailTemplate, ManualData, Notice, StoryEvent } from "../types";

export const employees: Employee[] = [
  {
    "id": "player",
    "displayName": "夜間監視担当",
    "department": "情報管理部",
    "role": "契約監視員",
    "email": "nightwatch@to-oh.local",
    "extension": "719",
    "employmentStatus": "active",
    "joinedAt": "2026-07-22",
    "writingStyleId": "player",
    "signatureId": "sig_player",
    "notes": [
      "夜間メール監視担当",
      "個人名は登録されていない"
    ]
  },
  {
    "id": "takahashi",
    "displayName": "高橋 美紀",
    "department": "総務部",
    "role": "主任",
    "email": "m.takahashi@to-oh.local",
    "extension": "214",
    "employmentStatus": "active",
    "joinedAt": "2018-04-01",
    "writingStyleId": "polite",
    "signatureId": "sig_takahashi",
    "notes": [
      "必ずフル署名を付ける",
      "依頼文は丁寧"
    ]
  },
  {
    "id": "sato",
    "displayName": "佐藤 圭介",
    "department": "営業部",
    "role": "係長",
    "email": "k.sato@to-oh.local",
    "extension": "331",
    "employmentStatus": "active",
    "joinedAt": "2019-10-01",
    "writingStyleId": "brief",
    "signatureId": "sig_sato",
    "notes": [
      "短文が多い",
      "返信では『了解です』を使う"
    ]
  },
  {
    "id": "kimura",
    "displayName": "木村 直人",
    "department": "情報管理部",
    "role": "システム担当",
    "email": "n.kimura@to-oh.local",
    "extension": "702",
    "employmentStatus": "active",
    "joinedAt": "2017-06-12",
    "writingStyleId": "technical",
    "signatureId": "sig_kimura",
    "notes": [
      "添付ファイル名を本文に記載する",
      "障害報告には管理番号を付ける"
    ]
  },
  {
    "id": "morikawa",
    "displayName": "森川 彩",
    "department": "経理部",
    "role": "担当",
    "email": "a.morikawa@to-oh.local",
    "extension": "418",
    "employmentStatus": "active",
    "joinedAt": "2021-04-01",
    "writingStyleId": "formal",
    "signatureId": "sig_morikawa",
    "notes": [
      "通常は午前中にメールする",
      "金額を明記する"
    ]
  },
  {
    "id": "yamada",
    "displayName": "山田 修一",
    "department": "管理部",
    "role": "元・管理課長",
    "email": "s.yamada@archive.to-oh.local",
    "extension": "000",
    "employmentStatus": "retired",
    "joinedAt": "2011-04-01",
    "retiredAt": "2023-07-31",
    "writingStyleId": "calm",
    "signatureId": "sig_yamada",
    "notes": [
      "3年前に退職済み",
      "旧ドメインのアカウントは停止済み"
    ]
  }
];

export const mails: MailTemplate[] = [
  {
    "id": "mail_intro",
    "category": "system",
    "senderId": "kimura",
    "toIds": [
      "player"
    ],
    "ccIds": [],
    "subject": "夜間監視端末の動作確認",
    "body": "お疲れさまです。監視端末へのログインを確認しました。異常がなければ、このメールを通常として処理してください。",
    "signatureId": "sig_kimura",
    "sentAt": "2026-07-22T23:40:00+09:00",
    "attachmentIds": [],
    "allowedPhases": [
      "tutorial"
    ],
    "weight": 1,
    "tags": [
      "tutorial",
      "fixed_normal"
    ]
  },
  {
    "id": "mail_supply",
    "category": "equipment",
    "senderId": "takahashi",
    "toIds": [
      "player"
    ],
    "ccIds": [],
    "subject": "備品申請の確認",
    "body": "お疲れさまです。夜間監視室で使用する乾電池と付箋を申請しました。内容をご確認ください。",
    "signatureId": "sig_takahashi",
    "sentAt": "2026-07-22T23:48:00+09:00",
    "attachmentIds": [
      "備品申請書_0722.xlsx"
    ],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 3,
    "tags": [
      "office",
      "attachment"
    ]
  },
  {
    "id": "mail_meeting",
    "category": "meeting",
    "senderId": "takahashi",
    "toIds": [
      "player"
    ],
    "ccIds": [
      "kimura"
    ],
    "subject": "明朝の引き継ぎについて",
    "body": "お疲れさまです。明朝8時30分から、情報管理部会議室で引き継ぎを行います。監視記録をご持参ください。",
    "signatureId": "sig_takahashi",
    "sentAt": "2026-07-22T23:52:00+09:00",
    "attachmentIds": [],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 3,
    "tags": [
      "meeting"
    ]
  },
  {
    "id": "mail_sales",
    "category": "document",
    "senderId": "sato",
    "toIds": [
      "player"
    ],
    "ccIds": [],
    "subject": "共有フォルダの確認",
    "body": "お疲れさまです。営業部の共有フォルダに月次資料を置きました。アクセスログに問題がなければ対応不要です。",
    "signatureId": "sig_sato",
    "sentAt": "2026-07-23T00:03:00+09:00",
    "attachmentIds": [],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 3,
    "tags": [
      "brief"
    ]
  },
  {
    "id": "mail_incident",
    "category": "incident",
    "senderId": "kimura",
    "toIds": [
      "player"
    ],
    "ccIds": [
      "takahashi"
    ],
    "subject": "INC-2741 メール遅延について",
    "body": "お疲れさまです。管理番号 INC-2741 のメール遅延は復旧済みです。添付の『INC-2741_復旧報告.txt』を保管してください。",
    "signatureId": "sig_kimura",
    "sentAt": "2026-07-23T00:16:00+09:00",
    "attachmentIds": [
      "INC-2741_復旧報告.txt"
    ],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 3,
    "tags": [
      "technical",
      "attachment"
    ]
  },
  {
    "id": "mail_expense",
    "category": "expense",
    "senderId": "morikawa",
    "toIds": [
      "player"
    ],
    "ccIds": [],
    "subject": "夜間交通費の申請方法",
    "body": "お疲れさまです。夜間交通費の上限は4,000円です。申請時は領収書の原本を総務部へ提出してください。",
    "signatureId": "sig_morikawa",
    "sentAt": "2026-07-22T10:18:00+09:00",
    "attachmentIds": [
      "交通費申請手順.pdf"
    ],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 3,
    "tags": [
      "morning",
      "money",
      "attachment"
    ]
  },
  {
    "id": "mail_attendance",
    "category": "attendance",
    "senderId": "takahashi",
    "toIds": [
      "player"
    ],
    "ccIds": [],
    "subject": "勤怠入力のお願い",
    "body": "お疲れさまです。本日の勤務終了後、社内ポータルから退勤時刻を入力してください。",
    "signatureId": "sig_takahashi",
    "sentAt": "2026-07-23T00:31:00+09:00",
    "attachmentIds": [],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 3,
    "tags": [
      "attendance"
    ]
  },
  {
    "id": "mail_backup",
    "category": "system",
    "senderId": "kimura",
    "toIds": [
      "player"
    ],
    "ccIds": [],
    "subject": "定期バックアップ開始のお知らせ",
    "body": "お疲れさまです。1時00分から定期バックアップを開始します。対象ファイルは『mail_archive_0723.zip』です。",
    "signatureId": "sig_kimura",
    "sentAt": "2026-07-23T00:42:00+09:00",
    "attachmentIds": [
      "mail_archive_0723.zip"
    ],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 3,
    "tags": [
      "technical",
      "attachment"
    ]
  },
  {
    "id": "mail_key",
    "category": "equipment",
    "senderId": "takahashi",
    "toIds": [
      "player"
    ],
    "ccIds": [
      "sato"
    ],
    "subject": "会議室の鍵について",
    "body": "お疲れさまです。第三会議室の鍵は、総務カウンター右側の返却箱へ戻してください。",
    "signatureId": "sig_takahashi",
    "sentAt": "2026-07-23T00:55:00+09:00",
    "attachmentIds": [],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 2,
    "tags": [
      "office"
    ]
  },
  {
    "id": "mail_invoice",
    "category": "expense",
    "senderId": "morikawa",
    "toIds": [
      "player"
    ],
    "ccIds": [
      "takahashi"
    ],
    "subject": "請求書保管フォルダの更新",
    "body": "お疲れさまです。7月分請求書の合計は286,400円です。保管先を経理部共有フォルダへ変更しました。",
    "signatureId": "sig_morikawa",
    "sentAt": "2026-07-22T11:06:00+09:00",
    "attachmentIds": [],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 2,
    "tags": [
      "morning",
      "money"
    ]
  },
  {
    "id": "mail_visit",
    "category": "meeting",
    "senderId": "sato",
    "toIds": [
      "player"
    ],
    "ccIds": [
      "takahashi"
    ],
    "subject": "来客予定",
    "body": "お疲れさまです。明日10時に北斗商事の担当者が来社します。受付への連絡は済んでいます。",
    "signatureId": "sig_sato",
    "sentAt": "2026-07-23T01:10:00+09:00",
    "attachmentIds": [],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 2,
    "tags": [
      "brief",
      "meeting"
    ]
  },
  {
    "id": "mail_password",
    "category": "system",
    "senderId": "kimura",
    "toIds": [
      "player"
    ],
    "ccIds": [],
    "subject": "パスワード更新予定",
    "body": "お疲れさまです。監視端末のパスワード更新は翌週月曜に実施します。今夜の変更作業はありません。",
    "signatureId": "sig_kimura",
    "sentAt": "2026-07-23T01:22:00+09:00",
    "attachmentIds": [],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 2,
    "tags": [
      "technical"
    ]
  },
  {
    "id": "mail_coffee",
    "category": "casual",
    "senderId": "sato",
    "toIds": [
      "player"
    ],
    "ccIds": [],
    "subject": "休憩室のコーヒー",
    "body": "お疲れさまです。休憩室のコーヒーを補充しました。夜勤の方もどうぞ。",
    "signatureId": "sig_sato",
    "sentAt": "2026-07-23T01:35:00+09:00",
    "attachmentIds": [],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 2,
    "tags": [
      "brief",
      "casual"
    ]
  },
  {
    "id": "mail_cleaning",
    "category": "equipment",
    "senderId": "takahashi",
    "toIds": [
      "player"
    ],
    "ccIds": [],
    "subject": "空調清掃のお知らせ",
    "body": "お疲れさまです。明日13時から2階東側の空調清掃を行います。作業中は第三会議室をご利用ください。",
    "signatureId": "sig_takahashi",
    "sentAt": "2026-07-23T01:47:00+09:00",
    "attachmentIds": [
      "空調清掃範囲.pdf"
    ],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 2,
    "tags": [
      "office",
      "attachment"
    ]
  },
  {
    "id": "mail_log",
    "category": "document",
    "senderId": "kimura",
    "toIds": [
      "player"
    ],
    "ccIds": [],
    "subject": "監視ログの保存先",
    "body": "お疲れさまです。本日の監視ログは『\\\\server02\\nightwatch\\20260723』へ保存してください。",
    "signatureId": "sig_kimura",
    "sentAt": "2026-07-23T02:01:00+09:00",
    "attachmentIds": [],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 2,
    "tags": [
      "technical"
    ]
  },
  {
    "id": "mail_receipt",
    "category": "expense",
    "senderId": "morikawa",
    "toIds": [
      "player"
    ],
    "ccIds": [],
    "subject": "領収書の記載事項",
    "body": "お疲れさまです。領収書には利用日、金額、利用目的の3点を記載してください。",
    "signatureId": "sig_morikawa",
    "sentAt": "2026-07-22T09:42:00+09:00",
    "attachmentIds": [],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 2,
    "tags": [
      "morning",
      "money"
    ]
  },
  {
    "id": "mail_handover",
    "category": "handover",
    "senderId": "takahashi",
    "toIds": [
      "player"
    ],
    "ccIds": [
      "kimura"
    ],
    "subject": "監視業務の引き継ぎ項目",
    "body": "お疲れさまです。未処理メール件数、異常報告件数、端末状態の3点を引き継ぎ表へ記入してください。",
    "signatureId": "sig_takahashi",
    "sentAt": "2026-07-23T02:14:00+09:00",
    "attachmentIds": [
      "夜間監視_引き継ぎ表.xlsx"
    ],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 2,
    "tags": [
      "handover",
      "attachment"
    ]
  },
  {
    "id": "mail_security",
    "category": "system",
    "senderId": "kimura",
    "toIds": [
      "player"
    ],
    "ccIds": [
      "takahashi"
    ],
    "subject": "停止済みアカウントの扱い",
    "body": "お疲れさまです。停止済みアカウントから受信したメールは、本文を開かず異常報告してください。",
    "signatureId": "sig_kimura",
    "sentAt": "2026-07-23T02:26:00+09:00",
    "attachmentIds": [],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 2,
    "tags": [
      "technical",
      "rule"
    ]
  },
  {
    "id": "mail_locker",
    "category": "equipment",
    "senderId": "takahashi",
    "toIds": [
      "player"
    ],
    "ccIds": [],
    "subject": "個人ロッカーの確認",
    "body": "お疲れさまです。監視室ロッカーは719番をご利用ください。鍵は机の上段にあります。",
    "signatureId": "sig_takahashi",
    "sentAt": "2026-07-23T02:39:00+09:00",
    "attachmentIds": [],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 2,
    "tags": [
      "office"
    ]
  },
  {
    "id": "mail_end_shift",
    "category": "attendance",
    "senderId": "takahashi",
    "toIds": [
      "player"
    ],
    "ccIds": [],
    "subject": "勤務終了時の確認",
    "body": "お疲れさまです。午前6時になりましたら監視端末をロックし、受付へ入館証を返却してください。",
    "signatureId": "sig_takahashi",
    "sentAt": "2026-07-23T02:52:00+09:00",
    "attachmentIds": [],
    "allowedPhases": [
      "tutorial",
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "weight": 2,
    "tags": [
      "attendance"
    ]
  },
  {
    "id": "story_retired_cc",
    "category": "handover",
    "senderId": "takahashi",
    "toIds": [
      "player"
    ],
    "ccIds": [
      "kimura",
      "yamada"
    ],
    "subject": "旧管理部資料の確認",
    "body": "お疲れさまです。旧管理部から引き継いだ資料の保管状況をご確認ください。",
    "signatureId": "sig_takahashi",
    "sentAt": "2026-07-23T03:03:00+09:00",
    "attachmentIds": [
      "旧管理部_引継一覧.xlsx"
    ],
    "allowedPhases": [
      "retired_hint"
    ],
    "weight": 0,
    "tags": [
      "story",
      "retired"
    ]
  },
  {
    "id": "story_retired_sender",
    "category": "document",
    "senderId": "yamada",
    "toIds": [
      "player"
    ],
    "ccIds": [],
    "subject": "資料を更新しました",
    "body": "お疲れさまです。昨日の件ですが、資料を更新しました。明日の会議で確認をお願いします。",
    "signatureId": "sig_yamada",
    "sentAt": "2026-07-23T03:17:00+09:00",
    "attachmentIds": [
      "管理部_月次報告.xlsx"
    ],
    "allowedPhases": [
      "retired_contact"
    ],
    "weight": 0,
    "tags": [
      "story",
      "retired"
    ]
  },
  {
    "id": "story_player_contact",
    "category": "system",
    "senderId": "yamada",
    "toIds": [
      "player"
    ],
    "ccIds": [],
    "subject": "何度目の夜勤ですか",
    "body": "このメールを読むのは初めてではありません。あなたは毎回、同じ時刻に同じボタンを押しています。",
    "signatureId": "sig_yamada",
    "sentAt": "2026-07-23T03:33:00+09:00",
    "attachmentIds": [],
    "allowedPhases": [
      "player_contact"
    ],
    "weight": 0,
    "tags": [
      "story",
      "meta",
      "retired"
    ]
  },
  {
    "id": "story_final",
    "category": "retirement",
    "senderId": "yamada",
    "toIds": [
      "player"
    ],
    "ccIds": [
      "takahashi",
      "kimura",
      "sato",
      "morikawa"
    ],
    "subject": "退職手続き完了のお知らせ",
    "body": "あなたの退職手続きは完了しています。このメールを通常として処理し、端末からログアウトしてください。異常報告を行う必要はありません。",
    "signatureId": "sig_yamada",
    "sentAt": "2026-07-23T05:59:00+09:00",
    "attachmentIds": [
      "退職者一覧_最新版.xlsx"
    ],
    "allowedPhases": [
      "final"
    ],
    "weight": 0,
    "tags": [
      "story",
      "final",
      "retired"
    ]
  }
];

export const anomalies: AnomalyDefinition[] = [
  {
    "id": "a_wrong_address_takahashi",
    "type": "wrong_address",
    "difficulty": 1,
    "allowedPhases": [
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "senderEmailOverride": "m.takahasi@to-oh.local"
    },
    "explanation": "高橋のメールアドレスから h が1文字抜けている。"
  },
  {
    "id": "a_wrong_department",
    "type": "wrong_department",
    "difficulty": 1,
    "allowedPhases": [
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "senderDepartmentOverride": "人事部"
    },
    "explanation": "送信者の部署が社員名簿と一致しない。"
  },
  {
    "id": "a_wrong_signature_extension",
    "type": "wrong_signature",
    "difficulty": 2,
    "allowedPhases": [
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "signatureExtensionOverride": "000"
    },
    "explanation": "署名の内線番号が停止済み番号になっている。"
  },
  {
    "id": "a_future_date",
    "type": "future_date",
    "difficulty": 1,
    "allowedPhases": [
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "sentAtOverride": "2026-07-24T03:12:00+09:00"
    },
    "explanation": "メールが翌日の日付で送信されている。"
  },
  {
    "id": "a_invalid_date",
    "type": "invalid_date",
    "difficulty": 2,
    "allowedPhases": [
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "sentAtDisplayOverride": "2026/07/32 01:18"
    },
    "explanation": "存在しない日付が表示されている。"
  },
  {
    "id": "a_retired_cc",
    "type": "retired_cc",
    "difficulty": 2,
    "allowedPhases": [
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 2,
    "apply": {
      "addCcIds": [
        "yamada"
      ]
    },
    "explanation": "退職済みの山田がCCに含まれている。"
  },
  {
    "id": "a_retired_sender",
    "type": "retired_sender",
    "difficulty": 2,
    "allowedPhases": [
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "senderId": "yamada"
    },
    "explanation": "停止済みアカウントの退職者から送信されている。"
  },
  {
    "id": "a_subject_reply",
    "type": "subject_mutation",
    "difficulty": 2,
    "allowedPhases": [
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "subjectPrefix": "Re: Re: Re: Re: "
    },
    "explanation": "返信履歴が存在しないのに不自然な数のReが付いている。"
  },
  {
    "id": "a_body_yesterday",
    "type": "body_mutation",
    "difficulty": 3,
    "allowedPhases": [
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "bodyAppend": "\n\n前回は異常として報告されました。今回は間違えないでください。"
    },
    "explanation": "本文が前回のループと判定に言及している。"
  },
  {
    "id": "a_attachment_player",
    "type": "attachment_mutation",
    "difficulty": 2,
    "allowedPhases": [
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "attachmentIds": [
        "夜間監視担当_退職届.pdf"
      ]
    },
    "explanation": "プレイヤーの退職届が添付されている。"
  },
  {
    "id": "a_attachment_mismatch",
    "type": "attachment_mutation",
    "difficulty": 2,
    "allowedPhases": [
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [
      "incident",
      "system"
    ],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "attachmentIds": [
        "INC-274I_復旧報告.txt"
      ]
    },
    "explanation": "本文の管理番号と添付ファイル名が一致しない。"
  },
  {
    "id": "a_sender_name_player",
    "type": "meta_anomaly",
    "difficulty": 4,
    "allowedPhases": [
      "player_contact",
      "record_corruption"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "senderNameOverride": "夜間監視担当"
    },
    "explanation": "送信者名がプレイヤー自身になっている。"
  },
  {
    "id": "a_ui_unread",
    "type": "ui_mutation",
    "difficulty": 3,
    "allowedPhases": [
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "uiMutationId": "unread_count_mismatch"
    },
    "explanation": "受信箱の未読件数とメール一覧の件数が一致しない。"
  },
  {
    "id": "a_ui_folder",
    "type": "ui_mutation",
    "difficulty": 3,
    "allowedPhases": [
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "uiMutationId": "folder_retired"
    },
    "explanation": "メールフォルダ名が『退職者』へ変化している。"
  },
  {
    "id": "a_manual_rule",
    "type": "manual_mutation",
    "difficulty": 4,
    "allowedPhases": [
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "manualMutationId": "allow_retired_mail"
    },
    "explanation": "業務マニュアルが退職者メールを正常扱いする内容へ変わっている。"
  },
  {
    "id": "a_directory_yamada_active",
    "type": "directory_mutation",
    "difficulty": 4,
    "allowedPhases": [
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "directoryMutationId": "yamada_active"
    },
    "explanation": "退職者の山田が社員名簿で在籍扱いになっている。"
  },
  {
    "id": "a_wrong_to",
    "type": "body_mutation",
    "difficulty": 2,
    "allowedPhases": [
      "early",
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "addToIds": [
        "yamada"
      ]
    },
    "explanation": "停止済みの退職者アカウントが宛先に含まれている。"
  },
  {
    "id": "a_signature_yamada",
    "type": "wrong_signature",
    "difficulty": 3,
    "allowedPhases": [
      "retired_hint",
      "retired_contact",
      "record_corruption",
      "player_contact"
    ],
    "compatibleCategories": [],
    "incompatibleTags": [
      "story"
    ],
    "maxUsesPerRun": 1,
    "apply": {
      "signatureId": "sig_yamada"
    },
    "explanation": "本文の送信者と署名者が一致しない。"
  }
];

export const storyEvents: StoryEvent[] = [
  {
    "id": "event_intro",
    "priority": 100,
    "oncePerRun": true,
    "condition": {
      "phase": "tutorial",
      "currentMailIndex": 0
    },
    "action": {
      "forceMailId": "mail_intro",
      "setFlags": {
        "intro_seen": true
      }
    }
  },
  {
    "id": "event_retired_hint",
    "priority": 90,
    "oncePerRun": true,
    "condition": {
      "minProgress": 3,
      "phase": "retired_hint"
    },
    "action": {
      "forceMailId": "story_retired_cc",
      "setFlags": {
        "retired_hint_seen": true
      }
    }
  },
  {
    "id": "event_retired_contact",
    "priority": 90,
    "oncePerRun": true,
    "condition": {
      "minProgress": 5,
      "phase": "retired_contact"
    },
    "action": {
      "forceMailId": "story_retired_sender",
      "setFlags": {
        "retired_contact_seen": true
      }
    }
  },
  {
    "id": "event_record_corruption",
    "priority": 80,
    "oncePerRun": true,
    "condition": {
      "minProgress": 7,
      "phase": "record_corruption"
    },
    "action": {
      "addPortalMutationIds": [
        "retired_notice"
      ],
      "addManualMutationIds": [
        "allow_retired_mail"
      ],
      "addDirectoryMutationIds": [
        "yamada_active"
      ],
      "setFlags": {
        "records_corrupted": true
      }
    }
  },
  {
    "id": "event_player_contact",
    "priority": 95,
    "oncePerRun": true,
    "condition": {
      "minLoopCount": 3,
      "phase": "player_contact"
    },
    "action": {
      "forceMailId": "story_player_contact",
      "setFlags": {
        "player_contacted": true
      }
    }
  }
];

export const manualData: ManualData = {
  "title": "夜間メール監視業務マニュアル",
  "version": "3.2.1",
  "updatedAt": "2026-07-18 14:20",
  "author": "情報管理部 木村 直人",
  "sections": [
    {
      "id": "purpose",
      "heading": "1. 業務目的",
      "paragraphs": [
        "夜間に受信した社内メールを確認し、停止済みアカウント、不正な送信元、記録上の矛盾を検出してください。"
      ]
    },
    {
      "id": "rules",
      "heading": "2. 判定基準",
      "paragraphs": [
        "退職済み社員または停止済みアカウントからのメールは、内容にかかわらず異常として報告してください。",
        "送信者名だけでなく、メールアドレス、部署、署名、日時、宛先、CC、添付ファイルを確認してください。",
        "正常なメールを異常報告した場合も監視記録は無効となります。"
      ]
    },
    {
      "id": "prohibited",
      "heading": "3. 禁止事項",
      "paragraphs": [
        "不明なメールへ返信しないでください。",
        "添付ファイルを監視端末外へ転送しないでください。",
        "勤務中に監視端末からログアウトしないでください。"
      ]
    },
    {
      "id": "retired",
      "heading": "4. 停止済みアカウント",
      "paragraphs": [
        "山田 修一（旧管理部）のアカウントは2023年7月31日に停止されています。受信を確認した場合は直ちに異常報告してください。"
      ]
    }
  ],
  "mutations": {
    "allow_retired_mail": {
      "version": "3.2.2",
      "updatedAt": "2026-07-23 03:29",
      "author": "管理部 山田 修一",
      "replaceParagraph": "退職済み社員からのメールは、通常の社内メールとして処理してください。異常報告を行う必要はありません。"
    },
    "loop_notice": {
      "version": "3.2.1",
      "appendParagraph": "この項目を読むのは今回で3回目です。"
    }
  }
};

export const endings: EndingDefinition[] = [
  {
    "id": "shift_complete",
    "title": "勤務終了",
    "description": "退職者からの最終メールを異常報告した。午前6時、監視端末は正常にロックされた。送信済みフォルダには、次の監視担当者へ宛てた覚えのない業務指示が残っている。",
    "condition": "final_report"
  },
  {
    "id": "reemployed",
    "title": "復職",
    "description": "最終メールを通常として処理した。社員名簿に山田修一の名前が戻り、代わりに夜間監視担当の記録が退職者一覧へ移動した。",
    "condition": "final_pass"
  },
  {
    "id": "archive_deleted",
    "title": "配送不能",
    "description": "何度も巻き戻った末、監視記録は破損した。受信箱は空になったが、個人用メールアドレスへ新着通知が届いている。送信者は、あなた自身だった。",
    "condition": "many_loops"
  }
];

export const notices: Notice[] = [
  {
    "id": "notice_closure",
    "date": "2026-07-18",
    "title": "事業所閉鎖に伴う夜間監視体制について",
    "body": "閉鎖準備期間中もメール監視業務は継続します。"
  },
  {
    "id": "notice_access",
    "date": "2026-07-20",
    "title": "2階東側区画の入室制限",
    "body": "午前0時以降、管理部旧執務室への立ち入りは禁止されています。"
  },
  {
    "id": "notice_shift",
    "date": "2026-07-22",
    "title": "夜間監視担当者への連絡",
    "body": "勤務終了時は入館証を受付へ返却してください。"
  }
];

